import React, { useEffect, useState } from "react"
import styled, { css } from "styled-components"
import { useStaticQuery, graphql } from "gatsby"

import useWindowSize from "hooks/useWindowSize"

import useInterval from "hooks/useInterval"
import { getNextIndex } from "components/Video"
import Img from "gatsby-image"

import { mediaDown } from "styles/media"

const Container = styled.div`
  display: none;

  ${mediaDown.small`
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: ${props => `${props.height}px`};
    overflow: hidden;
  `}
`

const Image = styled(Img)`
  position: absolute !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s;

  ${props =>
    props.visible &&
    css`
      opacity: 1;
      visibility: visible;
    `}
`

export default () => {
  const { allImageSharp } = useStaticQuery(graphql`
    query {
      allImageSharp(
        filter: {
          fluid: {
            originalName: {
              in: [
                "1.png"
                "2.png"
                "3.png"
                "4.png"
                "5.png"
                "6.png"
                "7.png"
                "8.png"
                "9.png"
                "10.png"
                "11.png"
                "12.png"
                "13.png"
                "14.png"
                "15.png"
                "16.png"
                "17.png"
                "18.png"
                "19.png"
                "20.png"
                "21.png"
                "22.png"
                "23.png"
                "24.png"
                "25.png"
                "26.png"
              ]
            }
          }
        }
      ) {
        nodes {
          id
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const images = allImageSharp.nodes
  const [activeIndex, setActiveIndex] = useState(null)

  const { height } = useWindowSize()

  useEffect(() => {
    const random = Math.floor(Math.random() * images.length) + 0
    setActiveIndex(random)
  }, [])

  useInterval(() => {
    const nextIndex = getNextIndex({
      currentIndex: activeIndex,
      maxIndex: images.length - 1
    })
    setActiveIndex(nextIndex)
  }, 6000)

  if (activeIndex !== 0 && !activeIndex) return null

  return (
    <Container height={height}>
      {images.map((image, index) => (
        <>
          <Image fluid={image.fluid} visible={index === activeIndex} />
        </>
      ))}
    </Container>
  )
}

// {images.map((image, index) => (
//   <Image fluid={image.fluid} visible={activeIndex === index} />
// ))}
